module.exports = __webpack_public_path__ + "337e93031f8907948872cee7e6bd0721.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/profile_pic.jpg
 ** module id = 11
 ** module chunks = 0
 **/